module.exports = __webpack_public_path__ + "img/header-engagementRingsHalo.75add06.webp";